import React, { useMemo } from 'react';

import ExpensesSelectableList, { Expense as ExpenseItem } from 'components/ExpensesSelectableList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { Expense } from 'models/expense';

interface Props {
  expenses?: Expense[];
  onSelect: (id: string) => void;
}

const ExpensesSelectableListContainer = ({ expenses, onSelect }: Props) => {
  const { t } = useStoreTranslation();

  const parsedExpenses = useMemo(
    () =>
      expenses?.map(
        (expense): ExpenseItem => ({
          id: expense.id as string,
          currency: expense.currencyCode,
          date: expense.date,
          name: expense.name || t(`expensesList.types.${expense.type.toLowerCase()}`),
          type: expense.type,
          value: expense.value,
          fromRappi: !!expense.rappiOrderId,
        }),
      ),
    [expenses, t],
  );

  const handleSelect = (expense: ExpenseItem) => {
    onSelect(expense.id);
  };

  return <ExpensesSelectableList expenses={parsedExpenses || []} isSelectable={false} onSelect={handleSelect} />;
};

export default ExpensesSelectableListContainer;
